module.exports = __webpack_public_path__ + "img/pointer.87b371f1.svg";